module.exports = __webpack_public_path__ + "img/744.51aa3716.jpg";